import { ISyncOptions } from '@/utils/ISyncOptions';

export default { } as ISyncOptions;